import React, { Component } from 'react';
import { createLogger } from '../utils/logger';
import { isChunkLoadError, reloadOnceForChunkError } from '../utils/chunkReload';

const logger = createLogger('Shell::ErrorBoundary');

class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null, errorInfo: null };
  }

  static getDerivedStateFromError() {
    // Update state so the next render will show the fallback UI
    return { hasError: true };
  }

  componentDidCatch(error, errorInfo) {
    logger.error("Error caught by ErrorBoundary:", error, errorInfo);
    // A file from an older build is gone — reload onto the current build instead.
    if (isChunkLoadError(error) && reloadOnceForChunkError()) return;
    this.setState({ error, errorInfo });
  }

  render() {
    if (this.state.hasError) {
      // You can render any custom fallback UI
      return (
        <div className="error-boundary">
          <h2>Something went wrong.</h2>
          <details>
            <summary>View details</summary>
            <p>{this.state.error && this.state.error.toString()}</p>
            <p>{this.state.errorInfo && this.state.errorInfo.componentStack}</p>
          </details>
          <button className="shell-button" onClick={() => window.location.reload()}>
            Reload page
          </button>
        </div>
      );
    }

    return this.props.children;
  }
}

export default ErrorBoundary;
